import React from "react";
import { useApiData } from "../../hooks/useFetch.js";
import { api } from "../../api/api.js";
import StateGuard from "../StateGuard.jsx";
import PhenoChart from "../charts/PhenoChart.jsx";
import PhenoGanttChart from "../charts/PhenoGanttChart.jsx";

export default function PhenologieTab({ baseParams, culture, libelle }) {
  const { data, loading, error } = useApiData(api.getPheno, baseParams, {
    skip: !baseParams.idProdu || !baseParams.gridno,
  });

  return (
    <StateGuard
      loading={loading}
      error={error}
      empty={!data || data.length === 0}
      emptyMessage="Pas de données phéno pour cette région / culture."
    >
      <div className="diagoeau-panel">
        <h3>Progression phénologique (GDD)</h3>
        {data && <PhenoChart data={data} />}
      </div>
      <div className="diagoeau-panel">
        <h3>Durée des stades phénologiques</h3>
        {data && <PhenoGanttChart data={data} />}
      </div>
    </StateGuard>
  );
}
